module.exports = __webpack_public_path__ + "static/media/logo.6a260d69.png";